import {BaseFormModel} from './base-form-model';

export class OrganizationDepositSummary extends BaseFormModel<OrganizationDepositSummary> {
    organizationId: number;
    name: string;
    depositCount: number;
    amount: number;
}
